import React, { useMemo, useCallback } from 'react';

import { useCurrentUser } from 'Auth';

import { View, Grid, Typography } from '@gogame/components';

import Review from './Review';
import { AddReviewForm } from './ReviewForm';

export const ReviewsList = ({
  data,
  isLoading,
  isRefetching,
  onAdd,
  onEdit,
  onRemove,
  columns,
  disableGutters,
}) => {
  const currentUser = useCurrentUser();

  const { ownReview, withoutOwnReviewList } = useMemo(() => {
    return (
      data?.reduce(
        (acc, item) => ({
          ...acc,
          ...(item.author.id === currentUser.id
            ? {
                ownReview: item,
              }
            : {
                withoutOwnReviewList: [
                  ...(acc.withoutOwnReviewList || []),
                  item,
                ],
              }),
        }),
        {}
      ) || {}
    );
  }, [data, currentUser.id]);

  const handleAddReview = useCallback((values) => onAdd(values), [onAdd]);

  const handleEditOwnReview = useCallback(
    (_, values) => onEdit({ ...values, id: ownReview.id }),
    [ownReview, onEdit]
  );

  const handleRemoveOwnReview = useCallback(() => {
    onRemove(ownReview);
  }, [ownReview, onRemove]);

  const reviewGridSize = columns ? 12 / columns : 12;

  return (
    <View loading={isLoading} fetching={isRefetching} transparent={true}>
      <Grid container spacing={3} p={disableGutters ? 0 : 2}>
        {!ownReview ? (
          <Grid item xs={12}>
            <AddReviewForm onSubmitClick={handleAddReview} />
          </Grid>
        ) : null}

        {data?.length ? (
          <Grid item container spacing={2} xs={12}>
            {ownReview ? (
              <Grid item xs={reviewGridSize}>
                <Review
                  author={ownReview.author.name}
                  date={ownReview.date}
                  message={ownReview.text}
                  mark={ownReview.mark}
                  withActions={true}
                  variant={'mark'}
                  onComment={handleEditOwnReview}
                  onDelete={handleRemoveOwnReview}
                  autoFocus={true}
                />
              </Grid>
            ) : null}
            {withoutOwnReviewList?.map(({ author, date, mark, text }) => (
              <Grid key={date} item xs={reviewGridSize}>
                <Review
                  author={author.name}
                  date={date}
                  message={text}
                  mark={mark}
                />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Grid item container alignItems={'center'} justifyContent={'center'}>
            <Grid item>
              <Typography color={'textSecondary'}>No reviews</Typography>
            </Grid>
          </Grid>
        )}
      </Grid>
    </View>
  );
};
